import { ChangeDetectorRef, Component, inject, PLATFORM_ID, ViewEncapsulation } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { GlobalMessageService, GlobalMessageType, OccConfig } from '@spartacus/core';
import { Observable, Subject, Subscription, BehaviorSubject } from 'rxjs';
import { DatePipe, isPlatformBrowser } from '@angular/common';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { CoreLookUpService } from 'src/app/services/feature/kb-my-cores/kbMyCores.service';
import { Router } from '@angular/router';
import moment from 'moment';
@Component({
  selector: 'app-core-search',
  templateUrl: './core-search.component.html',
  styleUrls: ['./core-search.component.scss'],
  providers: [DatePipe],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class CoreSearchComponent {
  private unsubscribe$ = new Subject<void>();
  today: Date;
  myCoreSearchData$: Observable<any> = this.coreService.getCoreSearchData();
  ToDate: any;
  FromDate: any;
  EndDate: Date;
  currentDate: Date = new Date();
  bsValue = new Date();
  defaultSoldTo: any;
  searchInput;
  bsconfigDate: string = '';
  selected: any;
  claimDate: Date;
  coreApiData1: any;
  endDateErrorFromApi: string = '';
  startDateErrorFromApi: string = '';
  FormData: any;
  showCustomerList: boolean = false;
  errorForGreaterStartDate: boolean = false;
  errorForGreaterEndDate: boolean = false;
  loading$ = new BehaviorSubject<boolean>(true);
  sortByCRM: string = undefined;
  sortByMonth: string = undefined;
  sortByStatus: string = undefined;
  sortByDate: string = undefined;

  baseUrl: string = this.config?.backend?.occ?.baseUrl + '/';

  coreApiData: any;

  isMobile: boolean = false;
  sub = new Subscription();

  //Method to initialize the form
  CoreSearchForm = new FormGroup({
    warrantyPartNo: new FormControl(null),
    coreCustomerNo: new FormControl(null),
    claimDateFrom: new FormControl(null, [Validators.required]),
    claimDateTo: new FormControl(null, [Validators.required]),
    showRequestsFromCoworkers: new FormControl(false),
  });
  BOLpdfUrl: any;
  isBolPdfAvailable: any = [];
  platformId = inject(PLATFORM_ID);
  constructor(
    public coreService: CoreLookUpService,
    private globalMsgService: GlobalMessageService,
    private cdr: ChangeDetectorRef,
    private datePipe: DatePipe,
    private globalMessageService: GlobalMessageService,
    private breakpointObserver: BreakpointObserver,
    private router: Router,
    private config: OccConfig
  ) {
    this.sub.add(
      this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).subscribe((result) => {
        this.isMobile = result.matches;
      })
    );
  }

  ngOnInit(): void {
    if (this.isMobile) {
      this.setCustomWidth();
    }
    this.getInitialData(true);

  }


  getInitialData(state) {
    this.myCoreSearchData$.subscribe((x: any) => {
      if (state) {
        this.defaultSoldTo = x.defaultSoldTo;
        this.bsconfigDate = x.dateFormat;
        this.CoreSearchForm.controls['showRequestsFromCoworkers'].setValue(x?.coWorkerOrders);
      }
      this.ToDate = new Date();
      this.FromDate = new Date(x.startDate);
      this.EndDate = new Date(x.endDate);
      //this.onSubmit();
      this.loading$.next(false);
      this.cdr.detectChanges();
    });
  }
  formatDateCustom(date: Date): string {
    let searchDate = '';
    searchDate = moment(date).format(this.bsconfigDate.toUpperCase());
    return searchDate;
  }

  formatDate(date: Date): string {
    return this.datePipe.transform(date, 'dd-MM-yyyy');
  }

  get Coreform() {
    return this.CoreSearchForm.controls;
  }

  // Method to handle form submission
  onSubmit(): void {
    this.errorForGreaterEndDate = false;
    this.errorForGreaterStartDate = false;
    if (this.CoreSearchForm.valid) {
      this.FormData = {
        defaultSoldTo: this.defaultSoldTo,
        claimNumber: this.CoreSearchForm.value.coreCustomerNo ? this.CoreSearchForm.value.coreCustomerNo.trim() : '',
        startDateString: this.formatDateCustom(this.CoreSearchForm.value.claimDateFrom),
        endDateString: this.formatDateCustom(this.CoreSearchForm.value.claimDateTo),
        coWorkerFlag: this.CoreSearchForm.value.showRequestsFromCoworkers ?? false,
      };


      this.postCoreData(0, 'byDateDesc');
    } else {
      const status = {
        message: 'common.text_contactusform_submission_error',
      };
      this.globalMessageService.add({ key: status?.message }, GlobalMessageType.MSG_TYPE_ERROR);
      this.sub.add(this.globalMessageService.get().subscribe((x) => {
      }));
    }
  }
  getBolPDf(crm, shipId, event, index) {
    event.preventDefault();
    this.coreService.getBOLpdf(crm, shipId, this.FormData).subscribe((x: any) => {
      this.BOLpdfUrl = x.billOfLadingPdf?.url;

      if (this.BOLpdfUrl) {
        this.isBolPdfAvailable[index] = true;
        if (isPlatformBrowser(this.platformId)) {
          const tempLink = document.createElement('a');
          tempLink.href = this.baseUrl + this.BOLpdfUrl;
          tempLink.download = '';
          tempLink.target = '_blank';
          document.body.appendChild(tempLink);
          tempLink.click();
          document.body.removeChild(tempLink);
        }
      }
      this.cdr.detectChanges();
    });
  }
  postCoreData(currentPage?, sortType?) {
    this.sub.add(this.coreService.postCoreSearchData(this.FormData, currentPage, sortType).subscribe((x: any) => {
      if (x?.kbStatusMessageWSDTO?.status == 'error' || x?.kbStatusMessageWSDTO?.status != undefined) {
        this.globalMsgService.add(
          {
            key: x?.kbStatusMessageWSDTO.message,
          },
          GlobalMessageType.MSG_TYPE_ERROR
        );

        if (x?.kbStatusMessageWSDTO?.endDateErrors[0]?.length > 0) {
          this.endDateErrorFromApi = x?.kbStatusMessageWSDTO.endDateErrors[0];
          this.errorForGreaterEndDate = true;
          this.cdr.detectChanges();
        }

        if (x?.kbStatusMessageWSDTO?.startDateErrors[0]?.length > 0) {
          this.startDateErrorFromApi = x?.kbStatusMessageWSDTO.startDateErrors[0];
          this.errorForGreaterStartDate = true;
          this.cdr.detectChanges();
        }
      } else {
        this.coreApiData = x;
        this.cdr.detectChanges();
      }
    }));
  }

  sort(type) {
    this.checkSortByDate(type);
    if (type == 'crm') {
      if (this.sortByCRM == 'asc') {
        this.sortByCRM = 'desc';
        this.postCoreData(0, 'byCrmNumberASC');
      } else if (this.sortByCRM == 'desc') {
        this.sortByCRM = 'asc';
        this.postCoreData(0, 'byClaimNumberDESC');
      } else {
        this.sortByCRM = 'desc';
        this.postCoreData(0, 'byCrmNumberASC');
      }
      this.sortByMonth = undefined;
      this.sortByStatus = undefined;
      this.sortByDate = undefined;
    }
    this.CheckSortByMonth(type);
    if (type == 'status') {
      if (this.sortByStatus == 'asc') {
        this.sortByStatus = 'desc';
        this.postCoreData(0, 'byStatusASC');
      } else if (this.sortByStatus == 'desc') {
        this.sortByStatus = 'asc';
        this.postCoreData(0, 'byStatusDESC');
      } else {
        this.sortByStatus = 'desc';
        this.postCoreData(0, 'byStatusASC');
      }
      this.sortByCRM = undefined;
      this.sortByMonth = undefined;
      this.sortByDate = undefined;
    }
  }

  checkSortByDate(type) {
    if (type == 'date') {
      if (this.sortByDate == 'asc') {
        this.sortByDate = 'desc';
        this.postCoreData(0, 'byCreationTimeASC');
      } else if (this.sortByDate == 'desc') {
        this.sortByDate = 'asc';
        this.postCoreData(0, 'byCreationTimeDESC');
      } else {
        this.sortByDate = 'desc';
        this.postCoreData(0, 'byCreationTimeASC');
      }
      this.sortByCRM = undefined;
      this.sortByMonth = undefined;
      this.sortByStatus = undefined;
    }
  }

  CheckSortByMonth(type) {
    if (type == 'month') {
      if (this.sortByMonth == 'asc') {
        this.sortByMonth = 'desc';
        this.postCoreData(0, 'byCoreMonthASC');
      } else if (this.sortByMonth == 'desc') {
        this.sortByMonth = 'asc';
        this.postCoreData(0, 'byCoreMonthDESC');
      } else {
        this.sortByMonth = 'desc';
        this.postCoreData(0, 'byCoreMonthASC');
      }

      this.sortByCRM = undefined;
      this.sortByStatus = undefined;
      this.sortByDate = undefined;
    }
  }

  showSearchResults($event: Event) {
    $event.stopPropagation();
    this.showCustomerList = !this.showCustomerList;
  }

  receiveData(data: any) {
    this.defaultSoldTo = data;
    this.showCustomerList = false;
    this.getInitialData(false);
  }

  setCustomWidth() {
    if (isPlatformBrowser(this.platformId)) {
      const widthInPixels = window.innerWidth - 10;
      document.documentElement.style.setProperty('--custom-table-width', `${widthInPixels}px`);
    }
  }

  getSavedCoreData(claimNo) {
    this.router.navigate(['kbCoreSubmissionPage'], {
      queryParams: { claimNo: claimNo },
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
